import {
  ordLanguageEnglish,
  resourcesLanguageEnglish as ordResourceLanguageEnglish,
  raLanguageEnglish,
} from '@ragu-components/ord-providers';
import { raFormLayoutLanguageEnglish } from '@ratto-components/ra-form-layout';
import { raRelationshipsLanguageEnglish } from '@ratto-components/ra-relationships';

import { callflowLanguageEnglish } from './callflows';
import { resourcesLanguageEnglish } from './resources';

import type { TranslationMessages } from './translationMessages';

export const languageEnglish: TranslationMessages = {
  ...raLanguageEnglish,
  ...raFormLayoutLanguageEnglish,
  ...raRelationshipsLanguageEnglish,
  ...callflowLanguageEnglish,
  ...ordLanguageEnglish,
  ...resourcesLanguageEnglish,
  ...ordResourceLanguageEnglish,
  ra: {
    ...raLanguageEnglish.ra,
    sort: {
      ...raLanguageEnglish.ra.sort,
      sort_by: 'Sort by %{field} %{order}',
    },
  },
  ord: {
    ...(ordLanguageEnglish.ord ?? {}),
    permissions: {
      ...(ordLanguageEnglish.ord?.permissions ?? {}),
      ap_configurations: 'Autoprovisioning Configurations',
      ap_groups: 'Autoprovisioning Groups',
      ap_authentication: 'Autoprovisioning Authentication',
      ap_settings: 'Autoprovisioning Settings',
      ap_templates: 'Autoprovisioning Templates',
      assigned_carriers: "Domain's SIP Trunks",
      assigned_inbound_e164s: "Domain's Inbound E164s",
      assigned_lcrs: "Domain's Least Cost Routing",
      assigned_sip_profiles: "Domain's SIP Profiles",
      calls: 'Calls',
      encryption_configurations: 'Storage Encryption Keys',
      presence: 'Presence',
      storage_configurations: 'External Storage Configurations',
    },
    validation: {
      ...(ordLanguageEnglish.ord?.validation ?? {}),
      pattern: 'Invalid format',
    },
    menu: {
      ...(ordLanguageEnglish.ord?.menu ?? {}),
      callManagementLabel: 'Call Management',
      stats: 'Statistics',
    },
  },
  callForwarding: {
    description: 'Manage your call forwarding rules',
    settingButtonLabel: 'Setup',
  },
  common: {
    unsavedChanges: {
      message: 'You have unsaved changes. Are you sure you want to leave?',
    },
  },
};
